<template>
  <div class="">
    <transition-group
        name="variant-list"
        tag="ul"
        class="block space-y-4 w-screen px-4 md:w-full"
    >
      <li
          v-for="menuVariant in variantsListPrio"
          :key="menuVariant.idx"
          class="font-bold text-sm block border-b border-gray-100"
      >
        <item-v2-variants-list
            :variant="menuVariant"
            :variant-data="variants[menuVariant.idx]"
            :item-facts="item.facts"
            :show-values="true"
            @patch="(event) => $emit('patch', event)"
        />
      </li>
    </transition-group>
    <transition-group
        name="variant-list"
        tag="ul"
        class="block space-y-4 w-screen px-4 md:w-full mt-4"
    >
      <li
          v-for="menuVariant in variantsList"
          :key="menuVariant.idx"
          class="font-bold text-base block border-b border-gray-100 pb-4"
      >
        <item-v2-variants-list
            :variant="menuVariant"
            :variant-data="variants[menuVariant.idx]"
            :item-facts="item.facts"
            @patch="(event) => $emit('patch', event)"
        />
      </li>
    </transition-group>
  </div>
</template>

<style>
.variant-list-enter-active,
.variant-list-leave-active {
  transition: all 0.3s ease;
}

.variant-list-enter-from,
.variant-list-leave-to {
  opacity: 0;
}

/* Ensure the list remains stable during transitions */
.variant-list-move {
  transition: transform 0.3s ease;
}
</style>

<script setup lang="ts">
import {computed, inject} from "vue";

import ItemV2VariantsList from "@/components/itemV2/itemV2VariantsList.vue";

defineEmits(["patch"]);

const props = defineProps([
  "itemIdx",
  "item",
  "sessionId"
]);
const loadItemVariants = inject<any>("loadItemVariants");

const variantsList = computed(() => {
  let listOfVariants: {
    idx: string;
    group: string;
    order: number,
    conf_group_idx: string;
    conf_groups_title: object,
    conf_groups: object;
    title: string;
  }[] = [];

  if (props.item && props.item.variants) {
    for (let variantIdx in props.item.variants) {
      const variant = props.item.variants[variantIdx];
      if (!variant) continue;

      if (variant.idx.indexOf("stone_type") !== -1) {
        loadItemVariants(props.itemIdx, variant.idx);
      }


      if (variant.prio === -1) {
        if (
            variant.conf_groups && Object.keys(variant.conf_groups).length !== 0
        ) {
          for (let conf_group_idx in variant.conf_groups) {
            listOfVariants.push({
              idx: variant.idx,
              group: variant.group?.title || "",
              order: variant.order,
              conf_group_idx: conf_group_idx,
              conf_groups: variant.conf_groups,
              conf_groups_title: variant.conf_groups_title,
              title: variant.title,
            });
          }
        } else {
          listOfVariants.push({
            idx: variant.idx,
            group: variant.group?.title || "",
            order: variant.order,
            conf_group_idx: "",
            conf_groups: variant.conf_groups,
            conf_groups_title: variant.conf_groups_title,
            title: variant.title,
          });
        }
      }
    }
  }

  listOfVariants.sort((a: any, b: any) => (a.order < b.order ? -1 : 1));

  return listOfVariants;
});

const variantsListPrio = computed(() => {
  let listOfVariants: {
    idx: string;
    prio: number;
    group: string;
    conf_group_idx: string;
    conf_groups: object;
    title: string;
  }[] = [];

  if (props.item && props.item.variants) {
    for (let variantIdx in props.item.variants) {
      const variant = props.item.variants[variantIdx];
      if (!variant) continue;
      if (variant.prio !== -1) {
        listOfVariants.push({
          idx: variant.idx,
          prio: variant.prio,
          group: variant.group?.title || "",
          conf_group_idx: "",
          conf_groups: variant.conf_groups,
          title: variant.title,
        });
      }
    }
  }

  listOfVariants.sort((a: any, b: any) => (a.prio < b.prio ? -1 : 1));

  return listOfVariants;
});

const variants = computed(() => {
  let variants: any = {};

  if (props.item && props.item.variants) {
    for (let variantIdx in props.item.variants) {
      const variant = props.item.variants[variantIdx];
      if (variant) {
        variants[variant.idx] = variant;
      }
    }
  }

  return variants;
});

</script>
